import { ServerDate } from "./server-date.class.ts"

export const isDateExpired = (date: Date | string | number): boolean =>
  new ServerDate(date).getTime() <= ServerDate.now()
